import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionShell } from '../SectionShell';
import { CtaButton } from '../CtaButton';
export function Guarantee() {
  return <SectionShell tone="white" data-id="element-172" data-mp="24n87akigckyv">
      <div className="rounded-3xl border border-renal-600/20 bg-renal-50 px-5 py-8 text-center sm:px-8" data-id="element-173" data-mp="24m5gsdp1kkjh">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-renal-500" data-id="element-174" data-mp="29eyi0rlaxaqt">
          <ShieldCheckIcon className="h-7 w-7 text-white" aria-hidden="true" data-id="element-175" data-mp="2ec8889gilqfp" />
        </span>
        <h2 className="mt-4 font-display text-[25px] font-extrabold leading-tight text-navy-900 sm:text-3xl" data-id="element-176" data-mp="2jb1ilt0i91bn">
          Garantía incondicional de 7 días
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-[14px] leading-relaxed text-navy-700/85 sm:text-base" data-id="element-177" data-mp="2scixj826ewyr">
          Explora todos los tomos. Revisa los algoritmos. Utilízalos en consulta. Si durante los
          próximos siete días sientes que Ruta Enfermedad Renal™ no te aporta mayor claridad clínica,
          simplemente escríbenos.
        </p>
        <p className="mt-4 font-display text-[18px] font-bold text-renal-700 sm:text-xl" data-id="element-178" data-mp="3smzox48cthz4">
          Te devolvemos el 100% de tu dinero.
        </p>
        <p className="mt-2 text-[13px] font-semibold text-navy-700/70 sm:text-sm" data-id="element-179" data-mp="3ivdhzk31u526">
          Sin explicaciones. Sin formularios interminables. Sin riesgos.
        </p>
      </div>

      <div className="mt-8" data-id="element-180" data-mp="3dupj6c8kwjxe">
        <CtaButton label="Quiero probarlo sin riesgo" sub="Tu compra está completamente protegida durante 7 días" data-id="element-181" data-mp="ffg6n7t5ir29" />
      </div>
    </SectionShell>;
}